import { Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

export const RightTypography = withStyles(theme => ({
    root: {
        marginLeft: theme.spacing(1),
    },
}))(Typography)
